import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { Dropdown, Menu } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskStatusType } from 'api/status-updates';
import { TaskType } from 'api/tasks';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { ResourceSectionType } from 'data/documents';
import { useTranslation } from 'hooks/use-translation';
import { INSERT_RESOURCE_LIST_SECTION_COMMAND } from 'vendor/ckeditor/plugins/resource-list-section';
import { Draggable } from '../draggable';
import {
  Ranges,
  rangeValueMap,
  StringRangePicker,
} from '../string-range-picker';
import { Count, getStatus, Props, TaskListSkelton } from './highlight-helpers';
import styles from './highlight.module.css';

export const Highlight: FC<Props> = ({
  commandName = INSERT_RESOURCE_LIST_SECTION_COMMAND,
  commandOptions,
  type,
}) => {
  const [rangeType, setRangeType] = useState<Ranges>(Ranges.Two);
  const inText = useTranslation('in');
  const nextText = useTranslation('next.connector');
  const pastText = useTranslation('past.connector');

  const onDateChange = (range) => {
    setRangeType(range);
  };

  const [taskTypeFilter, setTaskTypeFilter] = useState<TaskStatusType>(
    TaskStatusType.Completed,
  );

  const handleMenuItemClick = (e) => {
    setTaskTypeFilter(e.key);
  };

  const menu = (
    <Menu onClick={handleMenuItemClick}>
      <Menu.Item key={TaskStatusType.Completed}>
        <FormattedMessage id={`tasks.${TaskStatusType.Completed}`} />
      </Menu.Item>
      {type !== ResourceSectionType.Approval ? (
        <Menu.Item key={TaskStatusType.Blocked}>
          <FormattedMessage id={`tasks.${TaskStatusType.Blocked}`} />
        </Menu.Item>
      ) : null}

      <Menu.Item key={TaskStatusType.Overdue}>
        <FormattedMessage id={`tasks.${TaskStatusType.Overdue}`} />
      </Menu.Item>
      <Menu.Item key={TaskStatusType.Upcoming}>
        <FormattedMessage id={`tasks.${TaskStatusType.Upcoming}`} />
      </Menu.Item>
    </Menu>
  );

  const connectorTerm = `${inText} ${
    taskTypeFilter === TaskStatusType.Upcoming ? nextText : pastText
  }`;

  return (
    <Draggable
      type={type}
      commandName={commandName}
      commandOptions={{
        ...commandOptions,
        resourceTemplateSectionFilterType: taskTypeFilter,
        resourceTemplateSectionFilterRangeStr:
          taskTypeFilter !== TaskStatusType.Blocked
            ? `${connectorTerm} ${rangeType}`
            : '',
        resourceTemplateSectionFilterWeeksRange: rangeValueMap[rangeType],
        resourceTemplateSectionFilterWeeksRangeStr: rangeType,
      }}
    >
      <div className={styles.card}>
        <div className={styles.header}>
          <Dropdown overlay={menu} trigger={['click']}>
            <span className={styles.title}>
              <FormattedMessage id={`tasks.${taskTypeFilter}`} />
              <ChevronDown16 />
            </span>
          </Dropdown>
          {taskTypeFilter !== TaskStatusType.Blocked ? (
            <>
              <span className={styles.adder}>{connectorTerm}</span>

              <div className={styles.datepicker}>
                <StringRangePicker
                  onDateChange={onDateChange}
                  rangeType={rangeType}
                />
              </div>
            </>
          ) : null}
        </div>
        <div className={styles.info}>
          <Count>
            <StatusIndicator
              status={getStatus(taskTypeFilter)}
              type={
                type === ResourceSectionType.Milestone
                  ? TaskType.Milestone
                  : TaskType.Task
              }
            />
          </Count>
          <TaskListSkelton paragraph={{ rows: 3 }} title={false} />
        </div>
      </div>
    </Draggable>
  );
};
